import { ICommunication } from 'shared/types/redux';

export function isSuccededComm<T>(prev: ICommunication<T>, next: ICommunication<T>): boolean {
  return prev.isRequesting && !next.isRequesting && !next.error;
}

export function isCompletedComm<T>(prev: ICommunication<T>, next: ICommunication<T>): boolean {
  return !prev.completed && next.completed && !next.error;
}
